import { useSyncExternalStore } from 'react';

import { ToastStore } from './ToastStore';

export const useToastQueue = () =>
  useSyncExternalStore(ToastStore.subscribe, ToastStore.getSnapshot, ToastStore.getSnapshot);
